import { addServiceFeeAPI } from "@/global/api/cart";
import { getCheckoutCreditApi } from "@/global/api/credit";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useAppStore } from "@/global/store";
import { creditReportState } from "@/global/store/data/creditReport";
import { serviceFeeState } from "@/global/store/data/purchaseSeats/serviceFee";
import { selectCartManager } from "@/global/store/data/purchaseSeats/cartManager";
import {
  selectCredit,
  setCredit,
} from "@/global/store/data/purchaseSeats/credit";
import { selectUser } from "@/global/store/data/user";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToggle } from "@/shared/base/hooks/useToggle";

export const useAccountingApis = () => {
  const { teamSchema, availableCreditEnabled } = useTeamConfig();
  const dispatch = useDispatch();
  const getCheckoutCredit = useMutation(getCheckoutCreditApi);
  const addServiceFeeMutation = useMutation(addServiceFeeAPI);
  const { creditToUse } = useSelector(selectCredit);
  const cartState = useAppStore(selectCartManager);
  const serviceFeeErrorModal = useToggle();

  const handleAddServiceFee = async () => {
    try {
      const payload = {
        teamSchema,
        cartId: cartState.cartId as number,
        sessionId: cartState?.sessionId,
        totalAmount: cartState.allInPrice || 0,
        totalSeats: cartState.totalSeats || 0,
      };
      await addServiceFeeMutation.mutateAsync(payload, {
        onSuccess: ({ data }) => {
          dispatch(serviceFeeState.actions.setResponse(data));
        },
      });
    } catch (error) {
      console.log(error);
      serviceFeeErrorModal.onOpen();
    }
  };

  const getCheckoutCreditData = async () => {
    try {
      const payload = {
        teamSchema,
        tmCheckoutCredit: {
          cartId: cartState.cartId as number,
          totalAmount: cartState.allInPrice || 0,
          sessionId: cartState?.sessionId,
        },
      };
      await getCheckoutCredit.mutateAsync(payload, {
        onSuccess({ data }: any) {
          dispatch(setCredit(data));
          dispatch(
            creditReportState.actions.setAvailableCredit(data.creditInLedger)
          );
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleFetchAccountingData = async () => {
    await handleAddServiceFee();
    if (availableCreditEnabled) {
      await getCheckoutCreditData();
    }
  };

  useEffect(() => {
    handleFetchAccountingData();
  }, []);

  return {
    creditToUse,
    getCheckoutCredit,
    addServiceFeeMutation,
    serviceFeeErrorModal,
  };
};
